import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AdmihairBaseComponent } from '../../../admihair-base.component';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { Table } from 'primeng/table';
import { ConciliarConta } from 'src/app/admihair/api/dto/conciliar-conta';
import { ConciliarContaService } from 'src/app/admihair/service/conciliar-conta.service';
import { Conta } from 'src/app/admihair/api/dto/conta';
import { TipoPagamento } from 'src/app/admihair/api/dto/tipo-pagamento';
import { TrasnferenciaContaService } from 'src/app/admihair/service/transferencia-conta.service';
import { TipoPagamentoService } from 'src/app/admihair/service/tipo-pagamento.service';
import { TransferenciaConta } from 'src/app/admihair/api/dto/transferencia-conta';
import { forkJoin } from 'rxjs';
import { SelectItem } from 'primeng/api';

@Component({
  selector: 'app-conciliar-conta-listar',
  templateUrl: './conciliar-conta-listar.component.html',
  styleUrls: ['./conciliar-conta-listar.component.scss']
})
export class ConciliarContaListarComponent extends AdmihairBaseComponent implements OnInit {

  @ViewChild('filter') filter!: ElementRef;
  loading: boolean = false;
  loadingPrincipal: boolean = false;
  listaContas: ConciliarConta[] = [];

  exibirDialogTransferencia: boolean = false;
  loadingTransferir: boolean = false;
  exibirSpinnerDialogTransf: boolean = false;

  contaOrigemSelecionada?: Conta;
  listaTiposPagamentoContaOrigem: SelectItem[] = [];
  tipoPagamentoContaOrigemSelecionado?: TipoPagamento;

  listaTiposPagamentoContaDestino: SelectItem[] = [];
  tipoPagamentoContaDestinoSelecionado?: TipoPagamento;

  dataTransferencia: Date = new Date();
  valorTransferencia: number = 0;

  constructor(private conciliarContaService: ConciliarContaService,
    private transferenciaContaService: TrasnferenciaContaService,
    private tipoPagamentoService: TipoPagamentoService,
    erroService: ErroService,
    storageService: UtilStorageService
  ) { super(erroService, storageService) }

  ngOnInit(): void {
    this.verificarPermissoes();
    if (this.permissaoListar) {
      this.carregarConciliarContas();
    }
  }

  carregarConciliarContas() {
    this.loading = true;
    this.conciliarContaService.listarConciliarContasPorEmpresa(this.getEmpresa().id).subscribe({
      next: (data: ConciliarConta[]) => {
        this.listaContas = data;
        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  abrirDialogTransferencia(contaSelecionada: Conta) {
    this.contaOrigemSelecionada = contaSelecionada;
    this.tipoPagamentoContaOrigemSelecionado = undefined;
    this.tipoPagamentoContaDestinoSelecionado = undefined;
    this.dataTransferencia = new Date();
    this.valorTransferencia = 0;
    this.carregarTiposPagamentoTransferencia();
    this.exibirSpinnerDialogTransf = true;
    this.exibirDialogTransferencia = true;
  }

  carregarTiposPagamentoTransferencia() {
    forkJoin([
      this.tipoPagamentoService.listarPorEmpresaEContaEOperacaoInterno(this.getEmpresa().id, this.contaOrigemSelecionada?.id),
      this.tipoPagamentoService.listarPorEmpresaEOperacaoInterno(this.getEmpresa().id)
    ]).subscribe({
      next: ([tiposPagamentoOrigemResponse, tiposPagamentoDestinoResponse]) => {

        this.listaTiposPagamentoContaOrigem = tiposPagamentoOrigemResponse.map(
          item => ({ label: `${item.descricao} - ${item.operacao?.conta?.descricao}`, value: item })
        );

        if (tiposPagamentoOrigemResponse.length === 1) {
          this.tipoPagamentoContaOrigemSelecionado = tiposPagamentoOrigemResponse[0];
        }

        this.processarTiposPagamentoDestino(tiposPagamentoDestinoResponse);
        this.exibirSpinnerDialogTransf = false;
      },
      error: (err: any) => {
        this.exibirSpinnerDialogTransf = false;
        this.exibirDialogTransferencia = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  processarTiposPagamentoDestino(lista: TipoPagamento[]) {
    this.listaTiposPagamentoContaDestino = lista
      .filter(item => item.operacao?.conta?.id !== this.contaOrigemSelecionada?.id)
      .map(item => ({ label: `${item.descricao} - ${item.operacao?.conta?.descricao}`, value: item }));

    if (this.listaTiposPagamentoContaDestino.length === 1) {
      this.tipoPagamentoContaDestinoSelecionado = this.listaTiposPagamentoContaDestino[0].value;
    }
  }

  transferir() {
    this.loadingTransferir = true;
    const transferenciaRequest: TransferenciaConta = {
      tipoPagamentoOrigem: this.tipoPagamentoContaOrigemSelecionado,
      tipoPagamentoDestino: this.tipoPagamentoContaDestinoSelecionado,
      valorTransferido: this.valorTransferencia,
      data: this.dataTransferencia,
      usuario: this.getUsuarioLogadoSistema(),
      empresa: this.getEmpresa()
    }
    this.transferenciaContaService.transferir(transferenciaRequest).subscribe({
      next: () => {
        this.loadingTransferir = false;
        this.exibirDialogTransferencia = false;
        this.exibirMensagemSucesso();
        this.carregarConciliarContas();

      },
      error: (err: any) => {
        this.loadingTransferir = false;
        this.exibirDialogTransferencia = false;
        this.exibirMensagemErro(err);
      }
    })

  }

  buscar(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  limpar(table: Table) {
    table.clear();
    this.filter.nativeElement.value = '';
  }

  verificarPermissoes() {
    this.permissaoListar = this.verificarPermissao('PERM_LISTAR_CONCILIAR_CONTAS');
    this.permissaoInserir = this.verificarPermissao('PERM_TRANSFERIR_CONCILIAR_CONTAS');
  }

}
